// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2P73Q","right":"Footer_right__2Icba","buttons":"Footer_buttons__2lSN_"};